import { useEffect, useMemo, useRef, useState } from 'react';

type LongreadCountData = {
  active: string;
  idList: string[];
  count: number;
};

type UseProjectViewMetricParams = {
  projectId?: string;
  longreadCountData?: LongreadCountData | null;
  disabled?: boolean;
  entityType?: string;
  minScreens?: number;
  minSeconds?: number;
};

type MetricReadyState = {
  projectId?: string;
  value: 0 | 1;
};

const DEFAULT_MIN_SCREENS = 3;
const DEFAULT_MIN_SECONDS = 15;

export const useProjectViewMetric = ({
  projectId,
  longreadCountData,
  disabled,
  minScreens = DEFAULT_MIN_SCREENS,
  minSeconds = DEFAULT_MIN_SECONDS,
}: UseProjectViewMetricParams) => {
  const [metricReady, setMetricReady] = useState<MetricReadyState>({
    projectId,
    value: 0,
  });

  const accumulatedMsRef = useRef(0);
  const visibleSinceRef = useRef<number | null>(null);
  const timeReachedRef = useRef(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hasTrackedRef = useRef(false);

  const currentScreenIndex = useMemo(() => {
    if (!longreadCountData?.active || !longreadCountData?.idList?.length) return 0;
    const idx = longreadCountData.idList.indexOf(longreadCountData.active);
    return idx >= 0 ? idx + 1 : 0;
  }, [longreadCountData?.active, longreadCountData?.idList]);

  const screensReady = useMemo(() => {
    if (!longreadCountData?.count || longreadCountData.count < minScreens) return false;
    return currentScreenIndex >= minScreens;
  }, [currentScreenIndex, longreadCountData?.count, minScreens]);

  useEffect(() => {
    hasTrackedRef.current = false;
    timeReachedRef.current = false;
    accumulatedMsRef.current = 0;
    visibleSinceRef.current = null;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setMetricReady({
      projectId,
      value: 0,
    });
  }, [projectId]);

  useEffect(() => {
    if (!projectId || disabled) return undefined;

    const minMs = minSeconds * 1000;

    const clearPendingTimeout = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const getElapsedVisibleMs = () => {
      if (visibleSinceRef.current === null) return accumulatedMsRef.current;
      return accumulatedMsRef.current + Date.now() - visibleSinceRef.current;
    };

    const tryFinalize = () => {
      if (hasTrackedRef.current) return;
      if (!screensReady) return;
      if (!timeReachedRef.current && getElapsedVisibleMs() < minMs) return;

      hasTrackedRef.current = true;
      clearPendingTimeout();
      setMetricReady({
        projectId,
        value: 1,
      });
    };

    const markTimeReached = () => {
      timeReachedRef.current = true;
      clearPendingTimeout();
      tryFinalize();
    };

    const startVisibleTracking = () => {
      if (timeReachedRef.current) return;
      if (visibleSinceRef.current === null) {
        visibleSinceRef.current = Date.now();
      }

      const remainingMs = Math.max(0, minMs - getElapsedVisibleMs());
      clearPendingTimeout();
      timeoutRef.current = setTimeout(markTimeReached, remainingMs);
    };

    const stopVisibleTracking = () => {
      clearPendingTimeout();
      if (visibleSinceRef.current !== null) {
        accumulatedMsRef.current += Date.now() - visibleSinceRef.current;
        visibleSinceRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startVisibleTracking();
        return;
      }

      stopVisibleTracking();
    };

    if (getElapsedVisibleMs() >= minMs) {
      timeReachedRef.current = true;
    } else if (document.visibilityState === 'visible') {
      startVisibleTracking();
    }

    tryFinalize();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      stopVisibleTracking();
    };
  }, [disabled, minSeconds, projectId, screensReady]);

  return metricReady.projectId === projectId ? metricReady.value : 0;
};
import { useEffect, useMemo, useRef, useState } from 'react';

type LongreadCountData = {
  active: string;
  idList: string[];
  count: number;
};

type UseProjectViewMetricParams = {
  projectId?: string;
  longreadCountData?: LongreadCountData | null;
  disabled?: boolean;
  entityType?: string;
  minScreens?: number;
  minSeconds?: number;
};

type MetricReadyState = {
  projectId?: string;
  value: 0 | 1;
};

const DEFAULT_MIN_SCREENS = 3;
const DEFAULT_MIN_SECONDS = 15;

export const useProjectViewMetric = ({
  projectId,
  longreadCountData,
  disabled,
  minScreens = DEFAULT_MIN_SCREENS,
  minSeconds = DEFAULT_MIN_SECONDS,
}: UseProjectViewMetricParams) => {
  const [metricReady, setMetricReady] = useState<MetricReadyState>({
    projectId,
    value: 0,
  });

  const accumulatedMsRef = useRef(0);
  const visibleSinceRef = useRef<number | null>(null);
  const timeReachedRef = useRef(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hasTrackedRef = useRef(false);

  const currentScreenIndex = useMemo(() => {
    if (!longreadCountData?.active || !longreadCountData?.idList?.length) return 0;
    const idx = longreadCountData.idList.indexOf(longreadCountData.active);
    return idx >= 0 ? idx + 1 : 0;
  }, [longreadCountData?.active, longreadCountData?.idList]);

  const screensReady = useMemo(() => {
    if (!longreadCountData?.count || longreadCountData.count < minScreens) return false;
    return currentScreenIndex >= minScreens;
  }, [currentScreenIndex, longreadCountData?.count, minScreens]);

  useEffect(() => {
    hasTrackedRef.current = false;
    timeReachedRef.current = false;
    accumulatedMsRef.current = 0;
    visibleSinceRef.current = null;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setMetricReady({
      projectId,
      value: 0,
    });
  }, [projectId]);

  useEffect(() => {
    if (!projectId || disabled) return undefined;

    const minMs = minSeconds * 1000;

    const clearPendingTimeout = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const getElapsedVisibleMs = () => {
      if (visibleSinceRef.current === null) return accumulatedMsRef.current;
      return accumulatedMsRef.current + Date.now() - visibleSinceRef.current;
    };

    const tryFinalize = () => {
      if (hasTrackedRef.current) return;
      if (!screensReady) return;
      if (!timeReachedRef.current && getElapsedVisibleMs() < minMs) return;

      hasTrackedRef.current = true;
      clearPendingTimeout();
      setMetricReady({
        projectId,
        value: 1,
      });
    };

    const markTimeReached = () => {
      timeReachedRef.current = true;
      clearPendingTimeout();
      tryFinalize();
    };

    const startVisibleTracking = () => {
      if (timeReachedRef.current) return;
      if (visibleSinceRef.current === null) {
        visibleSinceRef.current = Date.now();
      }

      const remainingMs = Math.max(0, minMs - getElapsedVisibleMs());
      clearPendingTimeout();
      timeoutRef.current = setTimeout(markTimeReached, remainingMs);
    };

    const stopVisibleTracking = () => {
      clearPendingTimeout();
      if (visibleSinceRef.current !== null) {
        accumulatedMsRef.current += Date.now() - visibleSinceRef.current;
        visibleSinceRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startVisibleTracking();
        return;
      }

      stopVisibleTracking();
    };

    if (getElapsedVisibleMs() >= minMs) {
      timeReachedRef.current = true;
    } else if (document.visibilityState === 'visible') {
      startVisibleTracking();
    }

    tryFinalize();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      stopVisibleTracking();
    };
  }, [disabled, minSeconds, projectId, screensReady]);

  return metricReady.projectId === projectId ? metricReady.value : 0;
};
